import React from 'react'
import ItsMe from '../../assets/ItsMeright.png'
import{FaAward} from 'react-icons/fa'
import{FiUsers} from 'react-icons/fi'
import{VscFolderLibrary} from 'react-icons/vsc'
import './about.css'

const About = () => {
  return (
    <section id="about" className='card-container'>
      <h5>Get to Know</h5>
      <h2>About Me</h2>

      <div className="container about__container">
        <div className="about__me">
          <div className="about__me-image">
            <img src={ItsMe} alt="About" />
          </div>
        </div>

        <div className="about__content">

          <div className="about__cards">
            <article className="about__card">
              <FaAward  className='about__icon'/>
              <h5>Experience</h5>
              <small>Technical Officer <br /> (SEP 2022-23)</small>
            </article>
            <article className="about__card">
              <FiUsers  className='about__icon'/>
              <h5>Hackthons</h5>
              <div className='hacks_info'>
                <small>3 times winner</small>
                <small>1 time runnerup</small>
              </div>
            </article>
            <article className="about__card">
              <VscFolderLibrary  className='about__icon'/>
              <h5>Projects</h5>
              <small>working on Club & Dept Websites</small>
            </article>
          </div>
            <p>I am software geek, exploring multiple technologies. I want to be versitile to work on any technology that company wants me to work with. I quickly adapt to new circumstances. Efficient while working in collaborative team environment.</p>
          <p>
            <a href="#contact" className='btn btn-primary'>Let's Talk</a>
          </p>
        </div>
      </div>
    </section>
  )
}

export default About